// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-card-section[data-v-53375436]{padding-top:32px;padding-bottom:20px}@media(min-width:768px){.item-card-section[data-v-53375436]{padding-top:55px}}.title[data-v-53375436]{text-align:center;font-size:2.5rem;line-height:2.75rem;font-weight:700;margin-bottom:21px}@media(min-width:992px){.title[data-v-53375436]{font-size:3rem;line-height:3.5rem;margin-bottom:16px}}.item-card[data-v-53375436]{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
